import applyDefaultOptions from './applyDefaultOptions';
import { applyDefaultOptionsOnLoadFail } from './applyDefaultOptionsOnLoadFail';
import setFeatureSettings from './setFeatureSettings';
import OwsOptionsResponse from '../service/OwsOptionsResponse';
import { LoadState } from '../store/schema/OwsOptionsStore';
import getStore from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { makeGetRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import SurfaceActionsOptions from '../store/schema/options/SurfaceActionsOptions';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';

const GET_OUTLOOK_OPTIONS_URL: string = 'ows/v1.0/OutlookOptions';

var onOptionsLoadedPromise: Promise<void> = null;

export default action('loadOptions')(function loadOptions(): Promise<void> {
    switch (getStore().loadState) {
        case LoadState.OptionsLoading:
            return onOptionsLoadedPromise;
        case LoadState.OptionsLoaded:
            return Promise.resolve();
        case LoadState.OptionsNotLoaded:
        default:
            getStore().loadState = LoadState.OptionsLoading;
            return (onOptionsLoadedPromise = makeGetRequest(
                GET_OUTLOOK_OPTIONS_URL,
                undefined /* correlationId */,
                undefined /* returnFullResponse */,
                {
                    PreferOption: isFeatureEnabled('fwk-option-useRestCore') && 'Ows.UseRestCore',
                } /*customheaders*/
            ).then(outlookOptionsResponse => {
                processResponse(outlookOptionsResponse);
                onOptionsLoadedPromise = null;
            }));
    }
});

function processResponse(outlookOptionsResponse: OwsOptionsResponse) {
    if (outlookOptionsResponse) {
        if (outlookOptionsResponse.options) {
            outlookOptionsResponse.options.forEach(options => {
                if (options != null) {
                    if (options.feature == OwsOptionsFeatureType.SurfaceActions) {
                        options = GetFallBackSurfaceActionsIfNull(options as SurfaceActionsOptions);
                    }

                    setFeatureSettings(getStore(), options.feature, options);
                }
            });
        }

        applyDefaultOptions();
        getStore().loadState = LoadState.OptionsLoaded;
    } else {
        trace.info('Error loading options');
        applyDefaultOptionsOnLoadFail();
        getStore().loadState = LoadState.OptionsNotLoaded;
    }
}

function GetFallBackSurfaceActionsIfNull(options: SurfaceActionsOptions): SurfaceActionsOptions {
    options.readSurfaceActions = options.readSurfaceActions ? options.readSurfaceActions : [];
    options.readSurfaceAddins = options.readSurfaceAddins ? options.readSurfaceAddins : [];
    options.composeSurfaceActions = options.composeSurfaceActions
        ? options.composeSurfaceActions
        : [];
    options.composeSurfaceAddins = options.composeSurfaceAddins ? options.composeSurfaceAddins : [];
    return options;
}
